import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, MessageSquare, Facebook, Instagram, Star } from "lucide-react";
import { businessInfo } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-lg bg-green-600 grid place-items-center text-white font-black">HS</div>
            <div>
              <div className="text-white font-black tracking-tight">HAMILTON'S SMOG</div>
              <div className="text-xs text-slate-400">STAR Certified • Est. 2021</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            The fastest STAR-certified smog check near Novato and greater Marin County. Family owned, price-match guaranteed, and always honest.
          </p>
          <div className="flex gap-3 mt-5">
            <a href={businessInfo.reviewUrl} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-md bg-white/5 hover:bg-green-600 grid place-items-center transition-colors">
              <Star className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-md bg-white/5 hover:bg-green-600 grid place-items-center transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-md bg-white/5 hover:bg-green-600 grid place-items-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" /><a href={businessInfo.directionsUrl} target="_blank" rel="noreferrer" className="hover:text-white">{businessInfo.address}</a></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" /><a href={`tel:${businessInfo.phoneRaw}`} className="hover:text-white">{businessInfo.phone}</a></li>
            <li className="flex gap-3"><MessageSquare className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" /><a href={`tel:${businessInfo.textPhoneRaw}`} className="hover:text-white">{businessInfo.textPhone} (Call/Text)</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Hours</h4>
          <ul className="space-y-2 text-sm">
            {businessInfo.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-4">
                <span className="text-slate-400">{h.day}</span>
                <span className={h.time === "Closed" ? "text-green-400" : "text-white"}>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#services" className="hover:text-white">Services</a></li>
            <li><a href="/#specials" className="hover:text-white">Specials & Coupons</a></li>
            <li><a href="/#service-areas" className="hover:text-white">Service Areas</a></li>
            <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
            <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
            <li><a href={businessInfo.bookingUrl} target="_blank" rel="noreferrer" className="hover:text-white">Book Appointment</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Hamilton's Star Smog Check. All rights reserved.</p>
          <p>Serving Novato, San Rafael, Petaluma & all of Marin County.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
